// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__45EP+","content":"default_content__1Z15j","text":"default_text__bplaA"};